import { RiTeamLine } from '@remixicon/react';
import { Card, CardContent } from '@components/ui/Card';

const TopClientCard = ({ clientName, subtitle = 'Highest booking volume' }) => (
  <Card className="overflow-hidden !rounded-3xl !border !border-gray-100 !shadow-none">
    <CardContent className="p-4">
      <div className="text-xs text-gray-500 mb-1">Top Client</div>
      <div className="flex justify-between items-center">
        <div>
          <div className="text-lg font-semibold text-gray-900">{clientName || 'N/A'}</div>
          <div className="text-sm text-gray-500">{subtitle}</div>
        </div>
        <div className="w-10 h-10 bg-amber-50 rounded-full flex items-center justify-center">
          <RiTeamLine className="w-5 h-5 text-amber-400" />
        </div>
      </div>
    </CardContent>
  </Card>
);

export default TopClientCard;
